<div mat-dialog-content>
    <modal-pqrFormLaw (closeDialog)="onClose()" [formId]="formId"></modal-pqrFormLaw>
</div>